import { UseMutationOptions } from '@tanstack/react-query';

import { SchedulerWebHookCreateData } from '@playq/services-jobot-scheduler';
import { CommonSuccess, GenericFailure } from '@playq/services-shared';

import { services2 } from '/api/services2';
import { useEitherMutation } from '/api/service-hooks';

export const useWebHookCreate = (
  options?: UseMutationOptions<CommonSuccess, GenericFailure | Error, SchedulerWebHookCreateData>
) => {
  return useEitherMutation((id) => services2.intergrationsWebHookService.create(id), {
    ...options,
  });
};
